import { Event } from '@/event-bus/event';

export class CollapseMassEditRequestedEvent extends Event<void> {}
